// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#hashtag-list{position:absolute;margin-top:15px;background-color:#fff;border:1px solid #ccc;border-radius:3px;-webkit-box-shadow:0 4px 8px 0 rgba(34,47,62,.1);box-shadow:0 4px 8px 0 rgba(34,47,62,.1);display:inline-block;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;vertical-align:top;z-index:1150}#hashtag-list .hashtag{padding:5px 10px}#hashtag-list .hashtag.selected,#hashtag-list .hashtag:hover{background-color:#dee0e2}", ""]);
// Exports
module.exports = exports;
